import {
  DEFAULT_LOCALE,
  PRESENTING_LOCALES_MAP,
  type PresentingDbLocale,
  type PresentingLocale,
} from '@mentimeter/i18n-core';

export const getPresentingLocale = (language?: string): PresentingLocale => {
  return language && language in PRESENTING_LOCALES_MAP
    ? PRESENTING_LOCALES_MAP[language as PresentingDbLocale]
    : DEFAULT_LOCALE;
};
